// Same order snapshot (double-click, network retry) reuses the key;
// any change to the order gets a new one.
let current = null;

export const getCheckoutIdempotencyKey = (order) => {
  const snapshot = JSON.stringify(order);
  if (current?.snapshot !== snapshot) {
    const key =
      window.crypto?.randomUUID?.() ??
      `${Date.now()}-${Math.random().toString(36).slice(2)}`;
    current = { snapshot, key };
  }
  return current.key;
};

export const clearCheckoutIdempotencyKey = () => {
  current = null;
};
